import update from 'immutability-helper';

import {
  SET_TAXONOMIES_LOADING,
  GET_TAXONOMIES,
  GET_TERMS,
  SET_METADATA_GROUPS_LOADING,
  GET_METADATA_GROUPS,
  SET_CUSTOM_FIELDS,
  SET_CUSTOM_FIELDS_LOADING,
} from '../actions/Metadata';

const initialState = {
  taxonomies: [],
  loadingTaxonomies: false,
  customFields: [],
  loadingCustomFields: false,
  metadataGroups: [],
  loadingMetadataGroups: false,
};

export const Metadata = (state = initialState, action) => {
  switch (action.type) {
    case SET_TAXONOMIES_LOADING:
      return Object.assign({}, state, {
        loadingTaxonomies: action.loadingTaxonomies,
      });

    case GET_TAXONOMIES:
      return Object.assign({}, state, {
        taxonomies: action.taxonomies,
      });

    case GET_TERMS: {
      const {
        taxonomyId,
        terms,
      } = action;
      const taxonomyIndex = state.taxonomies.findIndex(t => (t.id === taxonomyId));
      return update(state, {
        taxonomies: {
          [taxonomyIndex]: {
            terms: {
              $set: terms,
            },
          },
        },
      });
    }

    case SET_METADATA_GROUPS_LOADING:
      return Object.assign({}, state, {
        loadingGroups: action.loadingGroups,
      });

    case GET_METADATA_GROUPS:
      return Object.assign({}, state, {
        metadataGroups: action.metadataGroups,
      });

    case SET_CUSTOM_FIELDS_LOADING:
      return Object.assign({}, state, {
        customFieldsLoading: action.loading,
      });

    case SET_CUSTOM_FIELDS:
      return Object.assign({}, state, {
        customFields: action.customFields,
      });

    default:
      return state;
  }
};
